export const TimeZoneList = [
  { value: 'Eire', label: 'Eire' },
  { value: 'Cuba', label: 'Cuba' },
  { value: 'Poland', label: 'Poland' },
  { value: 'Antarctica/Casey', label: 'Antarctica/Casey' },
  { value: 'Antarctica/DumontDUrville', label: 'Antarctica/DumontDUrville' },
  { value: 'Antarctica/Rothera', label: 'Antarctica/Rothera' },
  { value: 'Antarctica/Troll', label: 'Antarctica/Troll' },
  { value: 'Antarctica/McMurdo', label: 'Antarctica/McMurdo' },
  { value: 'Antarctica/Syowa', label: 'Antarctica/Syowa' },
  { value: 'Antarctica/Palmer', label: 'Antarctica/Palmer' },
  { value: 'Antarctica/Mawson', label: 'Antarctica/Mawson' },
  { value: 'Antarctica/Macquarie', label: 'Antarctica/Macquarie' },
  { value: 'Antarctica/Davis', label: 'Antarctica/Davis' },
  { value: 'Antarctica/Vostok', label: 'Antarctica/Vostok' },
  { value: 'Antarctica/South_Pole', label: 'Antarctica/South_Pole' },
  { value: 'GMT+0', label: 'GMT+0' },
  { value: 'PRC', label: 'PRC' },
  { value: 'Hongkong', label: 'Hongkong' },
  { value: 'US/Eastern', label: 'US/Eastern' },
  { value: 'US/East-Indiana', label: 'US/East-Indiana' },
  { value: 'US/Indiana-Starke', label: 'US/Indiana-Starke' },
  { value: 'US/Hawaii', label: 'US/Hawaii' },
  { value: 'US/Samoa', label: 'US/Samoa' },
  { value: 'US/Alaska', label: 'US/Alaska' },
  { value: 'US/Arizona', label: 'US/Arizona' },
  { value: 'US/Pacific', label: 'US/Pacific' },
  { value: 'US/Central', label: 'US/Central' },
  { value: 'US/Aleutian', label: 'US/Aleutian' },
  { value: 'US/Michigan', label: 'US/Michigan' },
  { value: 'US/Mountain', label: 'US/Mountain' },
  { value: 'MET', label: 'MET' },
  { value: 'EST5EDT', label: 'EST5EDT' },
  { value: 'Atlantic/St_Helena', label: 'Atlantic/St_Helena' },
  { value: 'Atlantic/Reykjavik', label: 'Atlantic/Reykjavik' },
  { value: 'Atlantic/Madeira', label: 'Atlantic/Madeira' },
  { value: 'Atlantic/South_Georgia', label: 'Atlantic/South_Georgia' },
  { value: 'Atlantic/Faeroe', label: 'Atlantic/Faeroe' },
  { value: 'Atlantic/Cape_Verde', label: 'Atlantic/Cape_Verde' },
  { value: 'Atlantic/Azores', label: 'Atlantic/Azores' },
  { value: 'Atlantic/Faroe', label: 'Atlantic/Faroe' },
  { value: 'Atlantic/Bermuda', label: 'Atlantic/Bermuda' },
  { value: 'Atlantic/Stanley', label: 'Atlantic/Stanley' },
  { value: 'Atlantic/Jan_Mayen', label: 'Atlantic/Jan_Mayen' },
  { value: 'Atlantic/Canary', label: 'Atlantic/Canary' },
  { value: 'Libya', label: 'Libya' },
  { value: 'Arctic/Longyearbyen', label: 'Arctic/Longyearbyen' },
  { value: 'Egypt', label: 'Egypt' },
  { value: 'Canada/Eastern', label: 'Canada/Eastern' },
  { value: 'Canada/Atlantic', label: 'Canada/Atlantic' },
  { value: 'Canada/Yukon', label: 'Canada/Yukon' },
  { value: 'Canada/Pacific', label: 'Canada/Pacific' },
  { value: 'Canada/Central', label: 'Canada/Central' },
  { value: 'Canada/Newfoundland', label: 'Canada/Newfoundland' },
  { value: 'Canada/Saskatchewan', label: 'Canada/Saskatchewan' },
  { value: 'Canada/Mountain', label: 'Canada/Mountain' },
  { value: 'Navajo', label: 'Navajo' },
  { value: 'Brazil/DeNoronha', label: 'Brazil/DeNoronha' },
  { value: 'Brazil/East', label: 'Brazil/East' },
  { value: 'Brazil/Acre', label: 'Brazil/Acre' },
  { value: 'Brazil/West', label: 'Brazil/West' },
  { value: 'ROK', label: 'ROK' },
  { value: 'Iran', label: 'Iran' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Factory', label: 'Factory' },
  { value: 'Kwajalein', label: 'Kwajalein' },
  { value: 'ROC', label: 'ROC' },
  { value: 'HST', label: 'HST' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Europe/Madrid', label: 'Europe/Madrid' },
  { value: 'Europe/Mariehamn', label: 'Europe/Mariehamn' },
  { value: 'Europe/Amsterdam', label: 'Europe/Amsterdam' },
  { value: 'Europe/Vienna', label: 'Europe/Vienna' },
  { value: 'Europe/Vaduz', label: 'Europe/Vaduz' },
  { value: 'Europe/Istanbul', label: 'Europe/Istanbul' },
  { value: 'Europe/Gibraltar', label: 'Europe/Gibraltar' },
  { value: 'Europe/Podgorica', label: 'Europe/Podgorica' },
  { value: 'Europe/Saratov', label: 'Europe/Saratov' },
  { value: 'Europe/London', label: 'Europe/London' },
  { value: 'Europe/Ulyanovsk', label: 'Europe/Ulyanovsk' },
  { value: 'Europe/Astrakhan', label: 'Europe/Astrakhan' },
  { value: 'Europe/Berlin', label: 'Europe/Berlin' },
  { value: 'Europe/Oslo', label: 'Europe/Oslo' },
  { value: 'Europe/Kaliningrad', label: 'Europe/Kaliningrad' },
  { value: 'Europe/Stockholm', label: 'Europe/Stockholm' },
  { value: 'Europe/Kyiv', label: 'Europe/Kyiv' },
  { value: 'Europe/Bratislava', label: 'Europe/Bratislava' },
  { value: 'Europe/Dublin', label: 'Europe/Dublin' },
  { value: 'Europe/Copenhagen', label: 'Europe/Copenhagen' },
  { value: 'Europe/Ljubljana', label: 'Europe/Ljubljana' },
  { value: 'Europe/Helsinki', label: 'Europe/Helsinki' },
  { value: 'Europe/Volgograd', label: 'Europe/Volgograd' },
  { value: 'Europe/Tallinn', label: 'Europe/Tallinn' },
  { value: 'Europe/Luxembourg', label: 'Europe/Luxembourg' },
  { value: 'Europe/Minsk', label: 'Europe/Minsk' },
  { value: 'Europe/Lisbon', label: 'Europe/Lisbon' },
  { value: 'Europe/Kirov', label: 'Europe/Kirov' },
  { value: 'Europe/Tiraspol', label: 'Europe/Tiraspol' },
  { value: 'Europe/Monaco', label: 'Europe/Monaco' },
  { value: 'Europe/Jersey', label: 'Europe/Jersey' },
  { value: 'Europe/Belgrade', label: 'Europe/Belgrade' },
  { value: 'Europe/Rome', label: 'Europe/Rome' },
  { value: 'Europe/Kiev', label: 'Europe/Kiev' },
  { value: 'Europe/Budapest', label: 'Europe/Budapest' },
  { value: 'Europe/Bucharest', label: 'Europe/Bucharest' },
  { value: 'Europe/Moscow', label: 'Europe/Moscow' },
  { value: 'Europe/Sarajevo', label: 'Europe/Sarajevo' },
  { value: 'Europe/Zurich', label: 'Europe/Zurich' },
  { value: 'Europe/Nicosia', label: 'Europe/Nicosia' },
  { value: 'Europe/Guernsey', label: 'Europe/Guernsey' },
  { value: 'Europe/Isle_of_Man', label: 'Europe/Isle_of_Man' },
  { value: 'Europe/Sofia', label: 'Europe/Sofia' },
  { value: 'Europe/Simferopol', label: 'Europe/Simferopol' },
  { value: 'Europe/Andorra', label: 'Europe/Andorra' },
  { value: 'Europe/Uzhgorod', label: 'Europe/Uzhgorod' },
  { value: 'Europe/Warsaw', label: 'Europe/Warsaw' },
  { value: 'Europe/Riga', label: 'Europe/Riga' },
  { value: 'Europe/Belfast', label: 'Europe/Belfast' },
  { value: 'Europe/Prague', label: 'Europe/Prague' },
  { value: 'Europe/Skopje', label: 'Europe/Skopje' },
  { value: 'Europe/Vilnius', label: 'Europe/Vilnius' },
  { value: 'Europe/Zaporozhye', label: 'Europe/Zaporozhye' },
  { value: 'Europe/Brussels', label: 'Europe/Brussels' },
  { value: 'Europe/Athens', label: 'Europe/Athens' },
  { value: 'Europe/Zagreb', label: 'Europe/Zagreb' },
  { value: 'Europe/Samara', label: 'Europe/Samara' },
  { value: 'Europe/Malta', label: 'Europe/Malta' },
  { value: 'Europe/Chisinau', label: 'Europe/Chisinau' },
  { value: 'Europe/San_Marino', label: 'Europe/San_Marino' },
  { value: 'Europe/Vatican', label: 'Europe/Vatican' },
  { value: 'Europe/Paris', label: 'Europe/Paris' },
  { value: 'Europe/Tirane', label: 'Europe/Tirane' },
  { value: 'Europe/Busingen', label: 'Europe/Busingen' },
  { value: 'GMT-0', label: 'GMT-0' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'EET', label: 'EET' },
  { value: 'W-SU', label: 'W-SU' },
  { value: 'MST', label: 'MST' },
  { value: 'Africa/Monrovia', label: 'Africa/Monrovia' },
  { value: 'Africa/Khartoum', label: 'Africa/Khartoum' },
  { value: 'Africa/Maputo', label: 'Africa/Maputo' },
  { value: 'Africa/Kigali', label: 'Africa/Kigali' },
  { value: 'Africa/Tripoli', label: 'Africa/Tripoli' },
  { value: 'Africa/Asmera', label: 'Africa/Asmera' },
  { value: 'Africa/Lagos', label: 'Africa/Lagos' },
  { value: 'Africa/Lubumbashi', label: 'Africa/Lubumbashi' },
  { value: 'Africa/Sao_Tome', label: 'Africa/Sao_Tome' },
  { value: 'Africa/Juba', label: 'Africa/Juba' },
  { value: 'Africa/Tunis', label: 'Africa/Tunis' },
  { value: 'Africa/Ouagadougou', label: 'Africa/Ouagadougou' },
  { value: 'Africa/Dakar', label: 'Africa/Dakar' },
  { value: 'Africa/Lome', label: 'Africa/Lome' },
  { value: 'Africa/Nairobi', label: 'Africa/Nairobi' },
  { value: 'Africa/Brazzaville', label: 'Africa/Brazzaville' },
  { value: 'Africa/Luanda', label: 'Africa/Luanda' },
  { value: 'Africa/Algiers', label: 'Africa/Algiers' },
  { value: 'Africa/Gaborone', label: 'Africa/Gaborone' },
  { value: 'Africa/Johannesburg', label: 'Africa/Johannesburg' },
  { value: 'Africa/Kampala', label: 'Africa/Kampala' },
  { value: 'Africa/Mbabane', label: 'Africa/Mbabane' },
  { value: 'Africa/Bamako', label: 'Africa/Bamako' },
  { value: 'Africa/Bangui', label: 'Africa/Bangui' },
  { value: 'Africa/Lusaka', label: 'Africa/Lusaka' },
  { value: 'Africa/Djibouti', label: 'Africa/Djibouti' },
  { value: 'Africa/Mogadishu', label: 'Africa/Mogadishu' },
  { value: 'Africa/Addis_Ababa', label: 'Africa/Addis_Ababa' },
  { value: 'Africa/Libreville', label: 'Africa/Libreville' },
  { value: 'Africa/Kinshasa', label: 'Africa/Kinshasa' },
  { value: 'Africa/Maseru', label: 'Africa/Maseru' },
  { value: 'Africa/Windhoek', label: 'Africa/Windhoek' },
  { value: 'Africa/Banjul', label: 'Africa/Banjul' },
  { value: 'Africa/Conakry', label: 'Africa/Conakry' },
  { value: 'Africa/Douala', label: 'Africa/Douala' },
  { value: 'Africa/Dar_es_Salaam', label: 'Africa/Dar_es_Salaam' },
  { value: 'Africa/Ndjamena', label: 'Africa/Ndjamena' },
  { value: 'Africa/Timbuktu', label: 'Africa/Timbuktu' },
  { value: 'Africa/Accra', label: 'Africa/Accra' },
  { value: 'Africa/Freetown', label: 'Africa/Freetown' },
  { value: 'Africa/Asmara', label: 'Africa/Asmara' },
  { value: 'Africa/Cairo', label: 'Africa/Cairo' },
  { value: 'Africa/Ceuta', label: 'Africa/Ceuta' },
  { value: 'Africa/Malabo', label: 'Africa/Malabo' },
  { value: 'Africa/Bujumbura', label: 'Africa/Bujumbura' },
  { value: 'Africa/Harare', label: 'Africa/Harare' },
  { value: 'Africa/El_Aaiun', label: 'Africa/El_Aaiun' },
  { value: 'Africa/Blantyre', label: 'Africa/Blantyre' },
  { value: 'Africa/Abidjan', label: 'Africa/Abidjan' },
  { value: 'Africa/Nouakchott', label: 'Africa/Nouakchott' },
  { value: 'Africa/Niamey', label: 'Africa/Niamey' },
  { value: 'Africa/Bissau', label: 'Africa/Bissau' },
  { value: 'Africa/Casablanca', label: 'Africa/Casablanca' },
  { value: 'Africa/Porto-Novo', label: 'Africa/Porto-Novo' },
  { value: 'Universal', label: 'Universal' },
  { value: 'NZ-CHAT', label: 'NZ-CHAT' },
  { value: 'UTC', label: 'UTC' },
  { value: 'Asia/Phnom_Penh', label: 'Asia/Phnom_Penh' },
  { value: 'Asia/Tehran', label: 'Asia/Tehran' },
  { value: 'Asia/Jerusalem', label: 'Asia/Jerusalem' },
  { value: 'Asia/Novosibirsk', label: 'Asia/Novosibirsk' },
  { value: 'Asia/Taipei', label: 'Asia/Taipei' },
  { value: 'Asia/Baku', label: 'Asia/Baku' },
  { value: 'Asia/Bishkek', label: 'Asia/Bishkek' },
  { value: 'Asia/Atyrau', label: 'Asia/Atyrau' },
  { value: 'Asia/Istanbul', label: 'Asia/Istanbul' },
  { value: 'Asia/Kathmandu', label: 'Asia/Kathmandu' },
  { value: 'Asia/Tashkent', label: 'Asia/Tashkent' },
  { value: 'Asia/Karachi', label: 'Asia/Karachi' },
  { value: 'Asia/Katmandu', label: 'Asia/Katmandu' },
  { value: 'Asia/Pyongyang', label: 'Asia/Pyongyang' },
  { value: 'Asia/Dili', label: 'Asia/Dili' },
  { value: 'Asia/Ho_Chi_Minh', label: 'Asia/Ho_Chi_Minh' },
  { value: 'Asia/Dhaka', label: 'Asia/Dhaka' },
  { value: 'Asia/Thimphu', label: 'Asia/Thimphu' },
  { value: 'Asia/Kashgar', label: 'Asia/Kashgar' },
  { value: 'Asia/Yangon', label: 'Asia/Yangon' },
  { value: 'Asia/Aqtobe', label: 'Asia/Aqtobe' },
  { value: 'Asia/Novokuznetsk', label: 'Asia/Novokuznetsk' },
  { value: 'Asia/Anadyr', label: 'Asia/Anadyr' },
  { value: 'Asia/Samarkand', label: 'Asia/Samarkand' },
  { value: 'Asia/Manila', label: 'Asia/Manila' },
  { value: 'Asia/Aden', label: 'Asia/Aden' },
  { value: 'Asia/Yerevan', label: 'Asia/Yerevan' },
  { value: 'Asia/Qostanay', label: 'Asia/Qostanay' },
  { value: 'Asia/Chita', label: 'Asia/Chita' },
  { value: 'Asia/Singapore', label: 'Asia/Singapore' },
  { value: 'Asia/Jakarta', label: 'Asia/Jakarta' },
  { value: 'Asia/Jayapura', label: 'Asia/Jayapura' },
  { value: 'Asia/Ust-Nera', label: 'Asia/Ust-Nera' },
  { value: 'Asia/Macao', label: 'Asia/Macao' },
  { value: 'Asia/Ujung_Pandang', label: 'Asia/Ujung_Pandang' },
  { value: 'Asia/Calcutta', label: 'Asia/Calcutta' },
  { value: 'Asia/Dacca', label: 'Asia/Dacca' },
  { value: 'Asia/Kuala_Lumpur', label: 'Asia/Kuala_Lumpur' },
  { value: 'Asia/Bahrain', label: 'Asia/Bahrain' },
  { value: 'Asia/Barnaul', label: 'Asia/Barnaul' },
  { value: 'Asia/Bangkok', label: 'Asia/Bangkok' },
  { value: 'Asia/Kamchatka', label: 'Asia/Kamchatka' },
  { value: 'Asia/Baghdad', label: 'Asia/Baghdad' },
  { value: 'Asia/Ulaanbaatar', label: 'Asia/Ulaanbaatar' },
  { value: 'Asia/Magadan', label: 'Asia/Magadan' },
  { value: 'Asia/Ulan_Bator', label: 'Asia/Ulan_Bator' },
  { value: 'Asia/Famagusta', label: 'Asia/Famagusta' },
  { value: 'Asia/Yekaterinburg', label: 'Asia/Yekaterinburg' },
  { value: 'Asia/Vladivostok', label: 'Asia/Vladivostok' },
  { value: 'Asia/Thimbu', label: 'Asia/Thimbu' },
  { value: 'Asia/Gaza', label: 'Asia/Gaza' },
  { value: 'Asia/Rangoon', label: 'Asia/Rangoon' },
  { value: 'Asia/Seoul', label: 'Asia/Seoul' },
  { value: 'Asia/Sakhalin', label: 'Asia/Sakhalin' },
  { value: 'Asia/Muscat', label: 'Asia/Muscat' },
  { value: 'Asia/Kuching', label: 'Asia/Kuching' },
  { value: 'Asia/Kuwait', label: 'Asia/Kuwait' },
  { value: 'Asia/Ashgabat', label: 'Asia/Ashgabat' },
  { value: 'Asia/Tomsk', label: 'Asia/Tomsk' },
  { value: 'Asia/Tbilisi', label: 'Asia/Tbilisi' },
  { value: 'Asia/Beirut', label: 'Asia/Beirut' },
  { value: 'Asia/Saigon', label: 'Asia/Saigon' },
  { value: 'Asia/Vientiane', label: 'Asia/Vientiane' },
  { value: 'Asia/Aqtau', label: 'Asia/Aqtau' },
  { value: 'Asia/Hebron', label: 'Asia/Hebron' },
  { value: 'Asia/Irkutsk', label: 'Asia/Irkutsk' },
  { value: 'Asia/Nicosia', label: 'Asia/Nicosia' },
  { value: 'Asia/Dubai', label: 'Asia/Dubai' },
  { value: 'Asia/Chungking', label: 'Asia/Chungking' },
  { value: 'Asia/Harbin', label: 'Asia/Harbin' },
  { value: 'Asia/Qyzylorda', label: 'Asia/Qyzylorda' },
  { value: 'Asia/Qatar', label: 'Asia/Qatar' },
  { value: 'Asia/Yakutsk', label: 'Asia/Yakutsk' },
  { value: 'Asia/Oral', label: 'Asia/Oral' },
  { value: 'Asia/Damascus', label: 'Asia/Damascus' },
  { value: 'Asia/Shanghai', label: 'Asia/Shanghai' },
  { value: 'Asia/Hovd', label: 'Asia/Hovd' },
  { value: 'Asia/Amman', label: 'Asia/Amman' },
  { value: 'Asia/Almaty', label: 'Asia/Almaty' },
  { value: 'Asia/Hong_Kong', label: 'Asia/Hong_Kong' },
  { value: 'Asia/Omsk', label: 'Asia/Omsk' },
  { value: 'Asia/Krasnoyarsk', label: 'Asia/Krasnoyarsk' },
  { value: 'Asia/Makassar', label: 'Asia/Makassar' },
  { value: 'Asia/Chongqing', label: 'Asia/Chongqing' },
  { value: 'Asia/Macau', label: 'Asia/Macau' },
  { value: 'Asia/Khandyga', label: 'Asia/Khandyga' },
  { value: 'Asia/Tokyo', label: 'Asia/Tokyo' },
  { value: 'Asia/Ashkhabad', label: 'Asia/Ashkhabad' },
  { value: 'Asia/Kolkata', label: 'Asia/Kolkata' },
  { value: 'Asia/Brunei', label: 'Asia/Brunei' },
  { value: 'Asia/Dushanbe', label: 'Asia/Dushanbe' },
  { value: 'Asia/Srednekolymsk', label: 'Asia/Srednekolymsk' },
  { value: 'Asia/Tel_Aviv', label: 'Asia/Tel_Aviv' },
  { value: 'Asia/Pontianak', label: 'Asia/Pontianak' },
  { value: 'Asia/Kabul', label: 'Asia/Kabul' },
  { value: 'Asia/Urumqi', label: 'Asia/Urumqi' },
  { value: 'Asia/Choibalsan', label: 'Asia/Choibalsan' },
  { value: 'Asia/Colombo', label: 'Asia/Colombo' },
  { value: 'Asia/Riyadh', label: 'Asia/Riyadh' },
  { value: 'CST6CDT', label: 'CST6CDT' },
  { value: 'WET', label: 'WET' },
  { value: 'GMT0', label: 'GMT0' },
  { value: 'Greenwich', label: 'Greenwich' },
  { value: 'Pacific/Guadalcanal', label: 'Pacific/Guadalcanal' },
  { value: 'Pacific/Gambier', label: 'Pacific/Gambier' },
  { value: 'Pacific/Niue', label: 'Pacific/Niue' },
  { value: 'Pacific/Majuro', label: 'Pacific/Majuro' },
  { value: 'Pacific/Marquesas', label: 'Pacific/Marquesas' },
  { value: 'Pacific/Rarotonga', label: 'Pacific/Rarotonga' },
  { value: 'Pacific/Pitcairn', label: 'Pacific/Pitcairn' },
  { value: 'Pacific/Johnston', label: 'Pacific/Johnston' },
  { value: 'Pacific/Palau', label: 'Pacific/Palau' },
  { value: 'Pacific/Tarawa', label: 'Pacific/Tarawa' },
  { value: 'Pacific/Norfolk', label: 'Pacific/Norfolk' },
  { value: 'Pacific/Honolulu', label: 'Pacific/Honolulu' },
  { value: 'Pacific/Kwajalein', label: 'Pacific/Kwajalein' },
  { value: 'Pacific/Saipan', label: 'Pacific/Saipan' },
  { value: 'Pacific/Tongatapu', label: 'Pacific/Tongatapu' },
  { value: 'Pacific/Truk', label: 'Pacific/Truk' },
  { value: 'Pacific/Chuuk', label: 'Pacific/Chuuk' },
  { value: 'Pacific/Guam', label: 'Pacific/Guam' },
  { value: 'Pacific/Efate', label: 'Pacific/Efate' },
  { value: 'Pacific/Samoa', label: 'Pacific/Samoa' },
  { value: 'Pacific/Wallis', label: 'Pacific/Wallis' },
  { value: 'Pacific/Auckland', label: 'Pacific/Auckland' },
  { value: 'Pacific/Kosrae', label: 'Pacific/Kosrae' },
  { value: 'Pacific/Ponape', label: 'Pacific/Ponape' },
  { value: 'Pacific/Galapagos', label: 'Pacific/Galapagos' },
  { value: 'Pacific/Nauru', label: 'Pacific/Nauru' },
  { value: 'Pacific/Funafuti', label: 'Pacific/Funafuti' },
  { value: 'Pacific/Pago_Pago', label: 'Pacific/Pago_Pago' },
  { value: 'Pacific/Bougainville', label: 'Pacific/Bougainville' },
  { value: 'Pacific/Fiji', label: 'Pacific/Fiji' },
  { value: 'Pacific/Port_Moresby', label: 'Pacific/Port_Moresby' },
  { value: 'Pacific/Easter', label: 'Pacific/Easter' },
  { value: 'Pacific/Chatham', label: 'Pacific/Chatham' },
  { value: 'Pacific/Noumea', label: 'Pacific/Noumea' },
  { value: 'Pacific/Kanton', label: 'Pacific/Kanton' },
  { value: 'Pacific/Tahiti', label: 'Pacific/Tahiti' },
  { value: 'Pacific/Midway', label: 'Pacific/Midway' },
  { value: 'Pacific/Kiritimati', label: 'Pacific/Kiritimati' },
  { value: 'Pacific/Fakaofo', label: 'Pacific/Fakaofo' },
  { value: 'Pacific/Yap', label: 'Pacific/Yap' },
  { value: 'Pacific/Wake', label: 'Pacific/Wake' },
  { value: 'Pacific/Pohnpei', label: 'Pacific/Pohnpei' },
  { value: 'Pacific/Apia', label: 'Pacific/Apia' },
  { value: 'Pacific/Enderbury', label: 'Pacific/Enderbury' },
  { value: 'Etc/GMT+10', label: 'Etc/GMT+10' },
  { value: 'Etc/GMT+1', label: 'Etc/GMT+1' },
  { value: 'Etc/GMT-10', label: 'Etc/GMT-10' },
  { value: 'Etc/GMT+0', label: 'Etc/GMT+0' },
  { value: 'Etc/GMT-12', label: 'Etc/GMT-12' },
  { value: 'Etc/GMT+9', label: 'Etc/GMT+9' },
  { value: 'Etc/GMT-14', label: 'Etc/GMT-14' },
  { value: 'Etc/GMT+3', label: 'Etc/GMT+3' },
  { value: 'Etc/GMT+11', label: 'Etc/GMT+11' },
  { value: 'Etc/GMT-13', label: 'Etc/GMT-13' },
  { value: 'Etc/GMT-4', label: 'Etc/GMT-4' },
  { value: 'Etc/GMT+8', label: 'Etc/GMT+8' },
  { value: 'Etc/GMT-11', label: 'Etc/GMT-11' },
  { value: 'Etc/GMT-0', label: 'Etc/GMT-0' },
  { value: 'Etc/GMT-5', label: 'Etc/GMT-5' },
  { value: 'Etc/GMT+5', label: 'Etc/GMT+5' },
  { value: 'Etc/GMT+6', label: 'Etc/GMT+6' },
  { value: 'Etc/GMT-6', label: 'Etc/GMT-6' },
  { value: 'Etc/Universal', label: 'Etc/Universal' },
  { value: 'Etc/UTC', label: 'Etc/UTC' },
  { value: 'Etc/GMT+12', label: 'Etc/GMT+12' },
  { value: 'Etc/GMT-1', label: 'Etc/GMT-1' },
  { value: 'Etc/GMT-7', label: 'Etc/GMT-7' },
  { value: 'Etc/GMT0', label: 'Etc/GMT0' },
  { value: 'Etc/Greenwich', label: 'Etc/Greenwich' },
  { value: 'Etc/GMT-2', label: 'Etc/GMT-2' },
  { value: 'Etc/GMT+7', label: 'Etc/GMT+7' },
  { value: 'Etc/Zulu', label: 'Etc/Zulu' },
  { value: 'Etc/GMT-8', label: 'Etc/GMT-8' },
  { value: 'Etc/GMT-3', label: 'Etc/GMT-3' },
  { value: 'Etc/GMT-9', label: 'Etc/GMT-9' },
  { value: 'Etc/UCT', label: 'Etc/UCT' },
  { value: 'Etc/GMT+2', label: 'Etc/GMT+2' },
  { value: 'Etc/GMT+4', label: 'Etc/GMT+4' },
  { value: 'Etc/GMT', label: 'Etc/GMT' },
  { value: 'Zulu', label: 'Zulu' },
  { value: 'GB', label: 'GB' },
  { value: 'EST', label: 'EST' },
  { value: 'Jamaica', label: 'Jamaica' },
  { value: 'Turkey', label: 'Turkey' },
  { value: 'PST8PDT', label: 'PST8PDT' },
  { value: 'NZ', label: 'NZ' },
  { value: 'Iceland', label: 'Iceland' },
  { value: 'Chile/Continental', label: 'Chile/Continental' },
  { value: 'Chile/EasterIsland', label: 'Chile/EasterIsland' },
  { value: 'Israel', label: 'Israel' },
  { value: 'UCT', label: 'UCT' },
  { value: 'Mexico/BajaSur', label: 'Mexico/BajaSur' },
  { value: 'Mexico/BajaNorte', label: 'Mexico/BajaNorte' },
  { value: 'Mexico/General', label: 'Mexico/General' },
  { value: 'GB-Eire', label: 'GB-Eire' },
  { value: 'Indian/Comoro', label: 'Indian/Comoro' },
  { value: 'Indian/Maldives', label: 'Indian/Maldives' },
  { value: 'Indian/Reunion', label: 'Indian/Reunion' },
  { value: 'Indian/Christmas', label: 'Indian/Christmas' },
  { value: 'Indian/Kerguelen', label: 'Indian/Kerguelen' },
  { value: 'Indian/Mauritius', label: 'Indian/Mauritius' },
  { value: 'Indian/Antananarivo', label: 'Indian/Antananarivo' },
  { value: 'Indian/Chagos', label: 'Indian/Chagos' },
  { value: 'Indian/Mayotte', label: 'Indian/Mayotte' },
  { value: 'Indian/Mahe', label: 'Indian/Mahe' },
  { value: 'Indian/Cocos', label: 'Indian/Cocos' },
  { value: 'America/Denver', label: 'America/Denver' },
  { value: 'America/Santiago', label: 'America/Santiago' },
  { value: 'America/Menominee', label: 'America/Menominee' },
  { value: 'America/Tortola', label: 'America/Tortola' },
  { value: 'America/Pangnirtung', label: 'America/Pangnirtung' },
  { value: 'America/Atikokan', label: 'America/Atikokan' },
  { value: 'America/Port_of_Spain', label: 'America/Port_of_Spain' },
  { value: 'America/Cayman', label: 'America/Cayman' },
  { value: 'America/Nuuk', label: 'America/Nuuk' },
  { value: 'America/Iqaluit', label: 'America/Iqaluit' },
  { value: 'America/Montevideo', label: 'America/Montevideo' },
  { value: 'America/Anguilla', label: 'America/Anguilla' },
  { value: 'America/Porto_Velho', label: 'America/Porto_Velho' },
  { value: 'America/Phoenix', label: 'America/Phoenix' },
  { value: 'America/Grand_Turk', label: 'America/Grand_Turk' },
  { value: 'America/Ciudad_Juarez', label: 'America/Ciudad_Juarez' },
  { value: 'America/Costa_Rica', label: 'America/Costa_Rica' },
  { value: 'America/Caracas', label: 'America/Caracas' },
  { value: 'America/St_Kitts', label: 'America/St_Kitts' },
  { value: 'America/Fort_Wayne', label: 'America/Fort_Wayne' },
  { value: 'America/Indiana/Tell_City', label: 'America/Indiana/Tell_City' },
  { value: 'America/Indiana/Indianapolis', label: 'America/Indiana/Indianapolis' },
  { value: 'America/Indiana/Knox', label: 'America/Indiana/Knox' },
  { value: 'America/Indiana/Winamac', label: 'America/Indiana/Winamac' },
  { value: 'America/Indiana/Vevay', label: 'America/Indiana/Vevay' },
  { value: 'America/Indiana/Marengo', label: 'America/Indiana/Marengo' },
  { value: 'America/Indiana/Vincennes', label: 'America/Indiana/Vincennes' },
  { value: 'America/Indiana/Petersburg', label: 'America/Indiana/Petersburg' },
  { value: 'America/Guatemala', label: 'America/Guatemala' },
  { value: 'America/Barbados', label: 'America/Barbados' },
  { value: 'America/Cordoba', label: 'America/Cordoba' },
  { value: 'America/Thule', label: 'America/Thule' },
  { value: 'America/Lima', label: 'America/Lima' },
  { value: 'America/Antigua', label: 'America/Antigua' },
  { value: 'America/Miquelon', label: 'America/Miquelon' },
  { value: 'America/Guayaquil', label: 'America/Guayaquil' },
  { value: 'America/Matamoros', label: 'America/Matamoros' },
  { value: 'America/Blanc-Sablon', label: 'America/Blanc-Sablon' },
  { value: 'America/Martinique', label: 'America/Martinique' },
  { value: 'America/Jujuy', label: 'America/Jujuy' },
  { value: 'America/Kralendijk', label: 'America/Kralendijk' },
  { value: 'America/Maceio', label: 'America/Maceio' },
  { value: 'America/Dawson_Creek', label: 'America/Dawson_Creek' },
  { value: 'America/Virgin', label: 'America/Virgin' },
  { value: 'America/Port-au-Prince', label: 'America/Port-au-Prince' },
  { value: 'America/Yellowknife', label: 'America/Yellowknife' },
  { value: 'America/Yakutat', label: 'America/Yakutat' },
  { value: 'America/Chicago', label: 'America/Chicago' },
  { value: 'America/Inuvik', label: 'America/Inuvik' },
  { value: 'America/Halifax', label: 'America/Halifax' },
  { value: 'America/Coral_Harbour', label: 'America/Coral_Harbour' },
  { value: 'America/Mazatlan', label: 'America/Mazatlan' },
  { value: 'America/Toronto', label: 'America/Toronto' },
  { value: 'America/Catamarca', label: 'America/Catamarca' },
  { value: 'America/Boa_Vista', label: 'America/Boa_Vista' },
  { value: 'America/Guyana', label: 'America/Guyana' },
  { value: 'America/Glace_Bay', label: 'America/Glace_Bay' },
  { value: 'America/Puerto_Rico', label: 'America/Puerto_Rico' },
  { value: 'America/Nassau', label: 'America/Nassau' },
  { value: 'America/Bogota', label: 'America/Bogota' },
  { value: 'America/Regina', label: 'America/Regina' },
  { value: 'America/Nome', label: 'America/Nome' },
  { value: 'America/Indianapolis', label: 'America/Indianapolis' },
  { value: 'America/Cambridge_Bay', label: 'America/Cambridge_Bay' },
  { value: 'America/Los_Angeles', label: 'America/Los_Angeles' },
  { value: 'America/Monterrey', label: 'America/Monterrey' },
  { value: 'America/Winnipeg', label: 'America/Winnipeg' },
  { value: 'America/Tegucigalpa', label: 'America/Tegucigalpa' },
  { value: 'America/Rainy_River', label: 'America/Rainy_River' },
  { value: 'America/Grenada', label: 'America/Grenada' },
  { value: 'America/Moncton', label: 'America/Moncton' },
  { value: 'America/Kentucky/Louisville', label: 'America/Kentucky/Louisville' },
  { value: 'America/Kentucky/Monticello', label: 'America/Kentucky/Monticello' },
  { value: 'America/Belem', label: 'America/Belem' },
  { value: 'America/Merida', label: 'America/Merida' },
  { value: 'America/Rosario', label: 'America/Rosario' },
  { value: 'America/Mendoza', label: 'America/Mendoza' },
  { value: 'America/Lower_Princes', label: 'America/Lower_Princes' },
  { value: 'America/Argentina/San_Juan', label: 'America/Argentina/San_Juan' },
  { value: 'America/Argentina/Cordoba', label: 'America/Argentina/Cordoba' },
  { value: 'America/Argentina/Jujuy', label: 'America/Argentina/Jujuy' },
  { value: 'America/Argentina/Rio_Gallegos', label: 'America/Argentina/Rio_Gallegos' },
  { value: 'America/Argentina/Salta', label: 'America/Argentina/Salta' },
  { value: 'America/Argentina/La_Rioja', label: 'America/Argentina/La_Rioja' },
  { value: 'America/Argentina/Catamarca', label: 'America/Argentina/Catamarca' },
  { value: 'America/Argentina/Ushuaia', label: 'America/Argentina/Ushuaia' },
  { value: 'America/Argentina/Mendoza', label: 'America/Argentina/Mendoza' },
  { value: 'America/Argentina/San_Luis', label: 'America/Argentina/San_Luis' },
  { value: 'America/Argentina/ComodRivadavia', label: 'America/Argentina/ComodRivadavia' },
  { value: 'America/Argentina/Tucuman', label: 'America/Argentina/Tucuman' },
  { value: 'America/Argentina/Buenos_Aires', label: 'America/Argentina/Buenos_Aires' },
  { value: 'America/Bahia_Banderas', label: 'America/Bahia_Banderas' },
  { value: 'America/El_Salvador', label: 'America/El_Salvador' },
  { value: 'America/Noronha', label: 'America/Noronha' },
  { value: 'America/Managua', label: 'America/Managua' },
  { value: 'America/Rio_Branco', label: 'America/Rio_Branco' },
  { value: 'America/Thunder_Bay', label: 'America/Thunder_Bay' },
  { value: 'America/Rankin_Inlet', label: 'America/Rankin_Inlet' },
  { value: 'America/St_Barthelemy', label: 'America/St_Barthelemy' },
  { value: 'America/Eirunepe', label: 'America/Eirunepe' },
  { value: 'America/Atka', label: 'America/Atka' },
  { value: 'America/Louisville', label: 'America/Louisville' },
  { value: 'America/Montserrat', label: 'America/Montserrat' },
  { value: 'America/St_Vincent', label: 'America/St_Vincent' },
  { value: 'America/North_Dakota/Beulah', label: 'America/North_Dakota/Beulah' },
  { value: 'America/North_Dakota/Center', label: 'America/North_Dakota/Center' },
  { value: 'America/North_Dakota/New_Salem', label: 'America/North_Dakota/New_Salem' },
  { value: 'America/Hermosillo', label: 'America/Hermosillo' },
  { value: 'America/St_Thomas', label: 'America/St_Thomas' },
  { value: 'America/Vancouver', label: 'America/Vancouver' },
  { value: 'America/Chihuahua', label: 'America/Chihuahua' },
  { value: 'America/Godthab', label: 'America/Godthab' },
  { value: 'America/Nipigon', label: 'America/Nipigon' },
  { value: 'America/Dominica', label: 'America/Dominica' },
  { value: 'America/Dawson', label: 'America/Dawson' },
  { value: 'America/Araguaina', label: 'America/Araguaina' },
  { value: 'America/Juneau', label: 'America/Juneau' },
  { value: 'America/Cayenne', label: 'America/Cayenne' },
  { value: 'America/Mexico_City', label: 'America/Mexico_City' },
  { value: 'America/Buenos_Aires', label: 'America/Buenos_Aires' },
  { value: 'America/Goose_Bay', label: 'America/Goose_Bay' },
  { value: 'America/Bahia', label: 'America/Bahia' },
  { value: 'America/St_Johns', label: 'America/St_Johns' },
  { value: 'America/Swift_Current', label: 'America/Swift_Current' },
  { value: 'America/New_York', label: 'America/New_York' },
  { value: 'America/Adak', label: 'America/Adak' },
  { value: 'America/Jamaica', label: 'America/Jamaica' },
  { value: 'America/Recife', label: 'America/Recife' },
  { value: 'America/Montreal', label: 'America/Montreal' },
  { value: 'America/Curacao', label: 'America/Curacao' },
  { value: 'America/Marigot', label: 'America/Marigot' },
  { value: 'America/Santa_Isabel', label: 'America/Santa_Isabel' },
  { value: 'America/Santarem', label: 'America/Santarem' },
  { value: 'America/Fortaleza', label: 'America/Fortaleza' },
  { value: 'America/Asuncion', label: 'America/Asuncion' },
  { value: 'America/Shiprock', label: 'America/Shiprock' },
  { value: 'America/Detroit', label: 'America/Detroit' },
  { value: 'America/Tijuana', label: 'America/Tijuana' },
  { value: 'America/Danmarkshavn', label: 'America/Danmarkshavn' },
  { value: 'America/Guadeloupe', label: 'America/Guadeloupe' },
  { value: 'America/Cancun', label: 'America/Cancun' },
  { value: 'America/Creston', label: 'America/Creston' },
  { value: 'America/Fort_Nelson', label: 'America/Fort_Nelson' },
  { value: 'America/Panama', label: 'America/Panama' },
  { value: 'America/Aruba', label: 'America/Aruba' },
  { value: 'America/Anchorage', label: 'America/Anchorage' },
  { value: 'America/Sao_Paulo', label: 'America/Sao_Paulo' },
  { value: 'America/La_Paz', label: 'America/La_Paz' },
  { value: 'America/Whitehorse', label: 'America/Whitehorse' },
  { value: 'America/Punta_Arenas', label: 'America/Punta_Arenas' },
  { value: 'America/Boise', label: 'America/Boise' },
  { value: 'America/Santo_Domingo', label: 'America/Santo_Domingo' },
  { value: 'America/Ojinaga', label: 'America/Ojinaga' },
  { value: 'America/Resolute', label: 'America/Resolute' },
  { value: 'America/Scoresbysund', label: 'America/Scoresbysund' },
  { value: 'America/Manaus', label: 'America/Manaus' },
  { value: 'America/Campo_Grande', label: 'America/Campo_Grande' },
  { value: 'America/Edmonton', label: 'America/Edmonton' },
  { value: 'America/Cuiaba', label: 'America/Cuiaba' },
  { value: 'America/Belize', label: 'America/Belize' },
  { value: 'America/Ensenada', label: 'America/Ensenada' },
  { value: 'America/Paramaribo', label: 'America/Paramaribo' },
  { value: 'America/Havana', label: 'America/Havana' },
  { value: 'America/Knox_IN', label: 'America/Knox_IN' },
  { value: 'America/Porto_Acre', label: 'America/Porto_Acre' },
  { value: 'America/Metlakatla', label: 'America/Metlakatla' },
  { value: 'America/St_Lucia', label: 'America/St_Lucia' },
  { value: 'America/Sitka', label: 'America/Sitka' },
  { value: 'MST7MDT', label: 'MST7MDT' },
  { value: 'CET', label: 'CET' },
  { value: 'GMT', label: 'GMT' },
  { value: 'Australia/Lindeman', label: 'Australia/Lindeman' },
  { value: 'Australia/South', label: 'Australia/South' },
  { value: 'Australia/Currie', label: 'Australia/Currie' },
  { value: 'Australia/Canberra', label: 'Australia/Canberra' },
  { value: 'Australia/Lord_Howe', label: 'Australia/Lord_Howe' },
  { value: 'Australia/Darwin', label: 'Australia/Darwin' },
  { value: 'Australia/Eucla', label: 'Australia/Eucla' },
  { value: 'Australia/Sydney', label: 'Australia/Sydney' },
  { value: 'Australia/LHI', label: 'Australia/LHI' },
  { value: 'Australia/Adelaide', label: 'Australia/Adelaide' },
  { value: 'Australia/Queensland', label: 'Australia/Queensland' },
  { value: 'Australia/Victoria', label: 'Australia/Victoria' },
  { value: 'Australia/Brisbane', label: 'Australia/Brisbane' },
  { value: 'Australia/Melbourne', label: 'Australia/Melbourne' },
  { value: 'Australia/Tasmania', label: 'Australia/Tasmania' },
  { value: 'Australia/NSW', label: 'Australia/NSW' },
  { value: 'Australia/Hobart', label: 'Australia/Hobart' },
  { value: 'Australia/ACT', label: 'Australia/ACT' },
  { value: 'Australia/Broken_Hill', label: 'Australia/Broken_Hill' },
  { value: 'Australia/North', label: 'Australia/North' },
  { value: 'Australia/Yancowinna', label: 'Australia/Yancowinna' },
  { value: 'Australia/Perth', label: 'Australia/Perth' },
  { value: 'Australia/West', label: 'Australia/West' }
]

export const timeZoneNames = () => {
  return TimeZoneList.map((tz) => {
    return tz.value
  })
}

export const CommonTimeZoneList = [
  { value: 'UTC', label: 'UTC' },
  { value: 'GMT+0', label: 'GMT+0' },
  { value: 'GMT0', label: 'GMT0' },
  { value: 'Brazil/East', label: 'Brazil/East' },
  { value: 'US/Central', label: 'US/Central' },
  { value: 'US/Eastern', label: 'US/Eastern' },
  { value: 'US/Pacific', label: 'US/Pacific' },
  { value: 'US/East-Indiana', label: 'US/East-Indiana' },
  { value: 'US/Indiana-Starke', label: 'US/Indiana-Starke' },
  { value: 'US/Hawaii', label: 'US/Hawaii' },
  { value: 'US/Samoa', label: 'US/Samoa' },
  { value: 'US/Alaska', label: 'US/Alaska' },
  { value: 'US/Arizona', label: 'US/Arizona' },
  { value: 'US/Aleutian', label: 'US/Aleutian' },
  { value: 'US/Michigan', label: 'US/Michigan' },
  { value: 'US/Mountain', label: 'US/Mountain' },

  { value: 'Canada/Eastern', label: 'Canada/Eastern' },
  { value: 'Canada/Atlantic', label: 'Canada/Atlantic' },
  { value: 'Canada/Yukon', label: 'Canada/Yukon' },
  { value: 'Canada/Pacific', label: 'Canada/Pacific' },
  { value: 'Canada/Central', label: 'Canada/Central' },
  { value: 'Canada/Newfoundland', label: 'Canada/Newfoundland' },
  { value: 'Canada/Saskatchewan', label: 'Canada/Saskatchewan' },
  { value: 'Canada/Mountain', label: 'Canada/Mountain' },

  { value: 'Asia/Calcutta', label: 'Asia/Calcutta' },
  { value: 'Asia/Bangkok', label: 'Asia/Bangkok' },
  { value: 'Asia/Dubai', label: 'Asia/Dubai' },
  { value: 'Asia/Dhaka', label: 'Asia/Dhaka' },
  { value: 'Asia/Kathmandu', label: 'Asia/Kathmandu' },
  { value: 'Asia/Katmandu', label: 'Asia/Katmandu' },
  { value: 'Asia/Singapore', label: 'Asia/Singapore' },
  { value: 'Asia/Tokyo', label: 'Asia/Tokyo' },

  { value: 'Europe/Berlin', label: 'Europe/Berlin' },
  { value: 'Europe/Athens', label: 'Europe/Athens' },
  { value: 'Europe/Moscow', label: 'Europe/Moscow' },

  { value: 'Australia/Sydney', label: 'Australia/Sydney' },
  { value: 'Australia/Adelaide', label: 'Australia/Adelaide' },
  { value: 'Australia/Queensland', label: 'Australia/Queensland' },
  { value: 'Australia/Victoria', label: 'Australia/Victoria' },
  { value: 'Australia/Brisbane', label: 'Australia/Brisbane' },
  { value: 'Australia/Melbourne', label: 'Australia/Melbourne' }
]
